<template>
  <div>
    <!--    <div style="margin: 10px 0 20px 0">-->
    <!--      <img src="../../../../../assets/images/logo-small.png" style="width: 140px" />-->
    <!--    </div>-->
    <!--    <gj-area-title>跟卖监控预警</gj-area-title>-->
    <!--    <div-->
    <!--      style="color: #666; font-size: 14px; margin-left: 16px; margin-top: -10px"-->
    <!--    >{{convertToFullDate(new Date(item.createTime), 'yyyy/MM/dd')}}</div>-->
    <!--    <div style="margin: 20px 0 20px 16px; font-size: 14px" v-html="item.title"></div>-->
    <template v-for="(val, index) in data">
      <gj-table
          ref="gjTable"
          :data="val.item || []"
          :columns="expandColumns"
          :adapt-height="false"
          width="100%"
          :index="false"
          :key="index"
          class="table-bottom"
      >
        <template v-slot:offerSellerId="{row}">{{ row.offerSellerId }}</template>
        <template v-slot:listingPrice="{row}">
          {{ row.listingPrice | amount | defaultShow(row.listingPriceCurrencySymbol) }}
        </template>
        <template v-slot:buyBoxWinner="{ row }">{{ row.buyBoxWinner ? "是" : "否" }}</template>
        <template v-slot:fulfillmentChannel="{ row }">{{ row.fulfillmentChannel }}</template>
        <template v-slot:fulfilledByAmazon="{ row }">{{ row.fulfilledByAmazon ? "亚马逊自营" : "普通卖家" }}</template>
        <template
            v-slot:followerInfo="{ row }"
        >
          {{ row.positiveFeedbackRating + "% positive over the past 12 months.(" + row.feedbackCount + "total ratings)" }}
        </template>
        <template v-slot:offerStartTime="{ row }">{{ row.offerStartTime }}</template>
        <template v-slot:offerEndTime="{ row }">{{ row.offerEndTime }}</template>
      </gj-table>
    </template>
  </div>
</template>

<script>
import {convertToFullDate} from "@/utils/date.util";

export default {
  name: "app-message-monitoringandearly-warning",
  props: {
    data: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      expandColumns: [
        {
          id: "offerSellerId",
          header: "Seller ID",
          field: "slot:offerSellerId",
          maxWidth: "100px",
          default: true
        },
        {
          id: "listingPrice",
          header: "跟卖价格",
          field: "slot:listingPrice",
          maxWidth: "100px",
          default: true
        },
        {
          id: "buyBoxWinner",
          header: "是否占领黄金购物区",
          field: "slot:buyBoxWinner",
          maxWidth: "100px",
          default: true
        },
        {
          id: "fulfillmentChannel",
          header: "跟卖类型",
          field: "slot:fulfillmentChannel",
          maxWidth: "100px",
          default: true
        },
        // {id: 'fulfilledByAmazon', header: '配送渠道', field: 'slot:fulfilledByAmazon',  maxWidth: '100px', default: true},
        {
          id: "followerInfo",
          header: "跟卖者信息",
          field: "slot:followerInfo",
          minWidth: "100px",
          maxWidth: "100px",
          default: true,
          overflowLine:2
        },
        {
          id: "offerStartTime",
          header: "跟卖开始时间",
          field: "slot:offerStartTime",
          minWidth: "50px",
          maxWidth: "100px",
          default: true
        }
        // {id: 'offerEndTime', header: '跟卖结束时间', field: 'slot:offerEndTime', minWidth: '50px', maxWidth: '100px', default: true},
      ],
      convertToFullDate: convertToFullDate
    };
  },
};
</script>

<style scoped>
.table-bottom{
  margin-bottom: 12px;
}
</style>
